export default __webpack_public_path__ + "static/media/401.c4c0a7d4.png";